import { styled } from "linaria/lib/react";
import { theme } from "@project/shared/src/theme";
import DropDown from "../../../assets/dropdown.svg";
import { Button } from "antd";
import { Link } from "theme-ui";
const Wrapper = /*#__PURE__*/styled("section")({
  name: "Wrapper",
  class: "w15pf47b"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "chdpqq1"
});
const TitleSection = /*#__PURE__*/styled("div")({
  name: "TitleSection",
  class: "trmftnu"
});
const BoxCollection = /*#__PURE__*/styled("div")({
  name: "BoxCollection",
  class: "b1h1ee72"
});
const Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "b1f1w8fx"
});
const Title = /*#__PURE__*/styled("h3")({
  name: "Title",
  class: "t1hy9hkf"
});
const BoxGroup = /*#__PURE__*/styled("div")({
  name: "BoxGroup",
  class: "bp9wv67"
});
const BoxItem = /*#__PURE__*/styled("div")({
  name: "BoxItem",
  class: "b1nxan3o"
});
const BoxFooter = /*#__PURE__*/styled("div")({
  name: "BoxFooter",
  class: "b182k3bk"
});
const CenterDiv = /*#__PURE__*/styled("div")({
  name: "CenterDiv",
  class: "c926ez3"
});
const ColoredBlock = /*#__PURE__*/styled("span")({
  name: "ColoredBlock",
  class: "c1qv0u0u",
  vars: {
    "c1qv0u0u-0": [props => props.isOrange ? theme.orange : theme.blue6]
  }
});

const ContactListFaculty = () => {
  return <Wrapper>
      <Container>
        <TitleSection>
          <h3>コワーケーション.comにあなたの施設や体験を掲載しませんか？</h3>
          <p>
            コワーケーション.comと一緒に、あたらしいコワーケーションの体験づくりをしていただける方を募集しています。お気軽にお問い合わせください。
          </p>
        </TitleSection>
        <BoxCollection>
          <Box>
            <Title>
              「体験」の場をつなげたい
              <ColoredBlock isOrange>施設事業者</ColoredBlock>の方
            </Title>
            <BoxGroup>
              {["ホテル・旅館", "キャンプ場", "会議施設", "研修施設", "リゾート施設", "MICE施設"].map((item, index) => {
              return <BoxItem key={`box_${index}`}>
                    <p>{item}</p>
                  </BoxItem>;
            })}
            </BoxGroup>
            <BoxFooter>
              <DropDown />
            </BoxFooter>
          </Box>
          <Box>
            <Title>
              「体験」を届けたい
              <ColoredBlock isOrange>コンテンツ事業者</ColoredBlock>の方
            </Title>
            <BoxGroup>
              {["研修・ゲームコンテンツ会社", "研修プログラム事業者", "ヨガ講師", "フィットネス講師", "地域ツアー事業者", "ファシリテーター"].map((item, index) => {
              return <BoxItem key={`box_${index}`}>
                    <p>{item}</p>
                  </BoxItem>;
            })}
            </BoxGroup>
            <BoxFooter>
              <DropDown />
            </BoxFooter>
          </Box>
        </BoxCollection>
        <CenterDiv>
          <Link href="/contact-registration#contact">
            <Button className="md" type="primary" size="large">
              事業者登録のお問い合わせ
            </Button>
            <Button type="primary" className="sm" size="large">
              お問い合わせ
            </Button>
          </Link>
        </CenterDiv>
      </Container>
    </Wrapper>;
};

export { ContactListFaculty };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");